<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="Branch" class="col-sm-2 col-form-label font-weight-bold">Branch</label>
            <div class="col-sm-6">
              <select name="tahun" id="branch" v-model="branch" class="custom-select custom-select-sm">
                <option v-for="bran in branchs" :value="bran.id">{{bran.name}}</option>
              </select>
            </div>
          </div>
          <div class="from-group row">
            <label for="" class="col-sm-2 col-form-label font-weight-bold">Date</label>
            <div class="col-sm-6">
              <template v-if="selected == 'normal'">
                <date-picker v-model="date" lang="en" format="MMMM YYYY" type="month"></date-picker>
              </template>
              <template v-else-if="selected == 'custom'">from: 
                <date-picker v-model="start" lang="en" format="DD/MM/YYYY"></date-picker>
                &nbsp; to: 
                <date-picker v-model="end" lang="en" format="DD/MM/YYYY"></date-picker>
              </template>
              <br>
              <b-form-group>
                <b-form-radio-group
                  v-model="selected"
                  :options="options"
                   name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          
          <div class="form-group row">
            <div class="col-sm-6">
              <button @click="submit" class="btn btn-primary">Submit</button>
            </div>
          </div>
          <b-row>
            <template v-if="listInsentif.length > 0">
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead>
                  <tr>
                    <th>No</th>
                    <th>Nama</th>
                    <th>TTS Open</th>
                    <th>TTS Closed</th>
                    <th>Insentif Open</th>
                    <th>Insentif Closed</th>
                    <th>Total Insentif</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(data, i) in listInsentif">
                    <tr :key="'insentif-' + i">
                      <td>{{i + 1}}</td>
                      <td>{{data.Name}}</td>
                      <td align="center">
                        <span @click="openDetail(data.open_detail, 'Open')" style="cursor: pointer">
                        {{data.Open}}
                        </span>
                        </td>
                      <td align="center">
                        <span @click="openDetail(data.solved_detail, 'Closed')" style="cursor: pointer">
                            {{data.Solved}}
                        </span>
                        </td>
                      <td align="right">{{(data.OpenInsentif || 0) | pointmoneynotCurrency}}</td>
                     <td align="right">{{(data.ClosedInsentif || 0) | pointmoneynotCurrency}}</td>
                      <td align="right">{{((data.OpenInsentif || 0)  + (data.ClosedInsentif || 0)) | pointmoneynotCurrency}}</td>
                    </tr>
                  </template>
                  <tr>
                    <td colspan="2" align="center">
                      Total
                    </td>
                    <td align="center">{{total.tts_open}}</td>
                    <td align="center">{{total.tts_closed}}</td>
                    <td align="right">{{total.insentif_open | pointmoneynotCurrency}}</td>
                    <td align="right">{{total.insentif_closed | pointmoneynotCurrency}}</td>
                    <td align="right">{{(total.insentif_open + total.insentif_closed) | pointmoneynotCurrency}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </template>
          </b-row>
        </b-card>

        <b-card v-if="urlDetail">
          <b-row>
            <detail-insentif-helpdesk
            :url="urlDetail"
            :typeTicket="typeTicket"
            />
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
    import {getService} from "../../../services";
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment'
    import DetailInsentifHelpdesk from './DetailInsentifHelpdesk'

    export default {
        components: {
            DatePicker,
            DetailInsentifHelpdesk
        },
        data() {
            return {
                branch: '',
                branchs: [],
                date: Date.now(),
                listInsentif: [],
                total: {
                    tts_open: 0,
                    tts_closed: 0,
                    insentif_open: 0,
                    insentif_closed: 0,
                },
                urlDetail: '',
                typeTicket: '',
                start: '',
                end: '',
                selected: 'normal',
                options: [
                  {text: 'Normal', value: 'normal'},
                  {text: 'Custom', value: 'custom'}
                ]
            }
        },
        created: function () {
            this.getBranch()
            this.start = moment().subtract(1, 'months').format('YYYY-MM-26')
            this.end = moment().format('YYYY-MM-25')
            let that = this
            if (this.$store.getters.branchInsentif) {
                this.branch = this.$store.getters.branchInsentif
            }else if (this.$store.getters.branchInVendor) {
                this.branch = this.$store.getters.branchInVendor
            } else {
                this.checkBranch = setInterval(() => {
                    that.branch = that.$store.getters.branch
                    if (that.branch) {
                        clearInterval(that.checkBranch)
                    }
                }, 1000);
            }
        },
        watch: {
          date: function(val) {
            this.start = moment(val).subtract(1, 'months').format('YYYY-MM-26')
            this.end = moment(val).format('YYYY-MM-25')
          }
        },
        methods: {
            getInsentif(branch, start, end) {
                this.$store.commit('noLoad', true)
                getService.list_insentif_branch(branch, start, end)
                    .then(data => {
                        this.$store.commit('noLoad', false)
                        this.listInsentif = data
                        this.total = {
                            tts_open: 0,
                            tts_closed: 0,
                            insentif_open: 0,
                            insentif_closed: 0,
                        }
                        for (let i in data) {
                            this.total.tts_open += data[i].Open || 0
                            this.total.tts_closed += data[i].Solved || 0
                            this.total.insentif_open += data[i].OpenInsentif || 0
                            this.total.insentif_closed += data[i].ClosedInsentif | 0
                        }
                    })
            },
            async getBranch() {
                try {
                    await getService.list_branch()
                        .then(data => {
                            this.branchs = data
                        })
                } catch (error) {
                    // bila data tidak terpanggil
                }

            },
            submit() {
              let start, end
               if (this.selected == 'custom') {
                 start = moment(this.start).format('YYYY-MM-DD')
                  end = moment(this.end).format('YYYY-MM-DD')
               } else {
                  start = moment(this.date, 'x').startOf('month').format('YYYY-MM-DD')
                  end = moment(this.date, 'x').endOf('month').format('YYYY-MM-DD')
               }
                this.getInsentif(this.branch, start, end)
            },
            openDetail(url, header) {
              this.typeTicket = header
              this.urlDetail = url
              setTimeout(() => {
                document.getElementById('detailInsentifHelpdesk').scrollIntoView({
                  behavior: 'smooth' 
                });
              }, 500)
            }
        }
    }
</script>
